import { render } from "./Link.vue.js?vue&type=template&id=04e2e808!=!../vue-loader/dist/index.js??ruleSet[0]!./Link.vue?vue&type=template&id=04e2e808"
import script from "./Link.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Link.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__